import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import Post_content from '../../../community/content/Blog_posts.jsx';
const LivestreamViewer = () => {

    return (
        <>
                  <div className="max-h-16">
                    <div className="cards">
                      <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: 'block' }}
                        format='horizontal'
                        responsive='false'
                      /></div>
                  </div>
            <div className="mx-2 ">
                <div className="mx-2 mx-auto max-w-2xl">
                    <form className=" add-form">
                        <div className="form-control">
                            <div className="text-base font-bold text-center">Hướng dẫn kiếm Coins</div>
                            <Post_content mode={'telegram'} show_adsense={'YES'} channel={'dangbaiok'} id_post={'18806'} />
                        </div>
                    </form>
                </div>
            </div>
            <div className="mx-2 ">
                <div className="mt-1 mx-2 mx-auto max-w-2xl">
                    <form className="add-form">
                        <div className="form-control">
                            <div className="text-base font-bold text-center">Chính sách nhận Coins</div>
                            <Post_content mode={'telegram'} show_adsense={'YES'} channel={'dangbaiok'} id_post={'18832'} />
                        </div>
                    </form>
                </div>
            </div>
            <br/> <br/>
        </>
    );
};

export default LivestreamViewer;
